<form [formGroup]="form">
  <div class="form-row padding--bottom-m">
    <mat-slide-toggle color="primary" formControlName="createSlutopgoerelse">Lav slutopgørelse</mat-slide-toggle>
  </div>
  @if (createSlutopgoerelse.value) {
    <div>
      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Intern bemærkning:</mat-label>
          <input matInput formControlName="slutopgoerelseRemark" />
        </mat-form-field>
      </div>
      <div class="form-row">
        <mat-radio-group formControlName="payUntilEndOfPeriod">
          <mat-radio-button [value]="true">Opkræves fuldt ud for perioden</mat-radio-button>
          <mat-radio-button [value]="false">Opkræves ikke for perioden</mat-radio-button>
        </mat-radio-group>
      </div>
      @if (isWithFrieTilkald) {
        <div class="form-row">
          <mat-slide-toggle color="primary" formControlName="tilvalgCorrection">Korrektion for frie tilkald/døgnservice: {{ frieTilkaldCorrectionAmount | dkCurrency }}</mat-slide-toggle>
          @if (!frieTilkaldCorrectionAmount) {
            <span [matTooltip]="priceError" [matTooltipDisabled]="!priceError"><strong>Kan ikke beregnes</strong></span>
          }
        </div>
      }
      <div class="form-row">
        <mat-slide-toggle formControlName="addManuelCorrection" color="primary">Manuel korrektion:</mat-slide-toggle>
        @if (addManuelCorrection) {
          <mat-form-field appearance="outline">
            <input matInput type="number" formControlName="manuelCorrection" />
            <span matSuffix>Kr. {{ momsSuffix }}</span>
          </mat-form-field>
        }
      </div>
    </div>
  }
</form>
